<h1 mat-dialog-title>Configuración de la columna "{{ companyProductPhaseBoardCol.title }}"</h1>

<mat-dialog-content [formGroup]="form" class="pb-3">
  <div class="container">
    <div class="row mt-3">
      <div class="col-12 col-lg-6">
        <mat-form-field appearance="outline" style="width: 100%">
          <mat-label>Roles</mat-label>
          <mat-select formControlName="company_product_phase_board_col_role_id">
            @for (role of companyProductPhaseBoardColRoles | keyvalue; track role) {
              <mat-option [value]="role.value.id">{{ role.value.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-12 col-lg-6">
        <p>
          {{ description }}
        </p>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button (click)="onCancel()" cdkFocusInitial type="button">Cancelar</button>
  <button mat-flat-button color="accent" [disabled]="!form.valid" type="submit" (click)="onSubmit()">Actualizar configuración</button>
</mat-dialog-actions>
